import { gql } from '@apollo/client'

export default gql`
  mutation RemoveFavoriteFilter($type: FavoriteSearchType!, $id: String!) {
    removeNFTFavoriteFilter(favoriteSearchType: $type, ID: $id)
  }
`
